<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.accountBankDetails" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="extractionRodDetails.hasPrivilege"
              label="Наличие льготы"
            />
          </v-col>
          <v-col v-if="extractionRodDetails.hasPrivilege" cols="12">
            <v-textarea
              v-model="$v.extractionRodDetails.note.$model"
              :errorMessages="
                getValidationErrorText($v.extractionRodDetails.note)
              "
              outlined
              label="Примечание (основание для льготы, при наличии)"
            />
            <span class="text-small-size">
              {{ Text.hasPrivilegeNote }}
            </span>
          </v-col>
        </v-row>
      </div>

      <Footer
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { maxLength, requiredIf } from 'vuelidate/lib/validators';
import cloneDeep from 'clone-deep';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { checkInvalid, Text, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { ExtractionRodStep } from '@/constants';

export default {
  name: 'AccountBankDetails',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    BankDetails,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    Text,
    getValidationErrorText,
    invalidFields: [],
    accountBankDetails: cloneDeep(bankDetails),
    extractionRodDetails: {
      hasPrivilege: false,
      note: '',
    },
  }),
  validations() {
    return {
      accountBankDetails: bankDetailsValidation,
      extractionRodDetails: {
        note: {
          required: requiredIf(() => this.extractionRodDetails.hasPrivilege),
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const statementBankDetails = ServicesModule.statement.accountBankDetails;
      const statementExtractionDetails =
        ServicesModule.statement.extractionRodDetails;

      if (statementBankDetails) {
        this.accountBankDetails = {
          ...this.accountBankDetails,
          ...statementBankDetails,
        };
      }

      if (statementExtractionDetails) {
        this.extractionRodDetails = {
          ...this.extractionRodDetails,
          ...statementExtractionDetails,
        };
      }
    },

    assemblyModel() {
      if (!this.extractionRodDetails.hasPrivilege) {
        this.extractionRodDetails.note = null;
      }

      return {
        accountBankDetails: {
          ...this.accountBankDetails,
        },
        extractionRodDetails: {
          ...this.extractionRodDetails,
        },
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: ExtractionRodStep.BANK_DETAILS,
      });
    },
  },
};
</script>
